import { useLang } from 'hooks/lang';

import { invoiceStatusConfig } from 'entities';

import { Row, Tag } from 'components/Blocks';

import { InvoiceByStatus } from './InvoiceByStatus';

import { formatCurrency } from 'utils/text';
import { sortByCurrency } from '../sorters';

export function SentToAccountant() {
  const { t } = useLang();

  return (
    <>
      <InvoiceByStatus
        status={invoiceStatusConfig.sentToAccountant.code}
        allowMultiSelection={false}
        columns={[
          {
            label: t('client-name') as string,
            property: 'clientName',
            filter: true,
            sort: true,
          },
          {
            label: t('type') as string,
            property: 'type',
            filter: true,
          },
          {
            label: t('value') as string,
            getTextValue: ({ currency }) => currency,
            filter: true,
            sort: true,
            sorter: sortByCurrency,
            render: ({ value, currency, cancelationRequestId }) => (
              <Row>
                {formatCurrency(value, currency)}

                {!!cancelationRequestId && (
                  <Tag name={t('cancelation-requested')} color="warning-light" round={false} />
                )}
              </Row>
            ),
          },
        ]}
      />
    </>
  );
}
